import OrdersApi from '@/api/order';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import '@/views_v2/apply-product/store';

const ApplyProductStore = namespace('applyProduct');

@Component
export default class ApplyBreak extends Vue {
    @ApplyProductStore.Action $updateState!: (data: Dictionary) => void;

    protected async getBrokenStatus(params:{
      productId?: string;
      productIdList?: string[];
    }):Promise<boolean> {
      return new Promise(async (resolve) => {
        const brokenStatus = await OrdersApi.getBrokenStatus(params);
        const {
          loanOrderId, popWindow, amount, canCancel, productId,
        } = brokenStatus || {};
        if (loanOrderId && popWindow) {
          this.$updateState({
            submitResult: {
              loanOrderId,
            },
            brokenAmount: amount,
            canCancel,
            brokenProductId: productId,
          });
        }
        if (popWindow) {
          resolve(true);
        }
        resolve(false);
      });
    }
}
